import React from 'react'
import "./SubStyle.css"

const Opera_Setup = () => {
  return (
     <section className="OurServices">
     <h1 className="OurServices-title">New Business Set Up</h1>
      <p className="OurServices-pera">Starting a care business requires careful planning, regulatory compliance, and a strong operational foundation. We provide expert guidance throughout the entire setup process, helping you establish policies, procedures, registrations, and systems that position your business for long-term success.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Opera_Setup
